import * as React from 'react';
import { EventDriver, ErrorType, JsonHelper } from '@/common/Utils';
import Alert from 'antd/lib/alert';
import message from 'antd/lib/message';
import 'antd/lib/message/style'
import "antd/lib/alert/style";
import './index.less';
import { Result, Icon } from 'antd-mobile';
import { DingTalk } from '@/common/DingTalk';

let errorLock = false

/**
 * 钉钉组件
 * 
 * 针对钉钉容器，添加了相应的生命周期
 */
export class DingComponent<P = {}, S = {}, SS = any> extends React.Component<P, S, SS> {
  /** 当页面重新可见并可交互时 */
  componentResume?(): void
  /** 当页面不可见的时候 */
  componentPause?(): void
  /** 当页面标题被双击的时候 */
  componentNavTitle?(): void
  /** 当网络由无网络到网络连接的时候 */
  componentNetworkOnline?(): void
  /** 当网络由连接到断开的时候 */
  componentNetworkOffline?(): void

  componentWillMount () {
    this.componentResume && document.addEventListener('resume', this.componentResume.bind(this));
    this.componentPause && document.addEventListener('pause', this.componentPause.bind(this));
    this.componentNavTitle && document.addEventListener('navTitle', this.componentNavTitle.bind(this));
    this.componentNetworkOnline && document.addEventListener('online', this.componentNetworkOnline.bind(this));
    this.componentNetworkOffline && document.addEventListener('offline', this.componentNetworkOffline.bind(this));
  }

  componentWillUnmount () {
    this.componentResume && document.removeEventListener('resume', this.componentResume.bind(this));
    this.componentPause && document.removeEventListener('pause', this.componentPause.bind(this));
    this.componentNavTitle && document.removeEventListener('navTitle', this.componentNavTitle.bind(this));
    this.componentNetworkOnline && document.removeEventListener('online', this.componentNetworkOnline.bind(this));
    this.componentNetworkOffline && document.removeEventListener('offline', this.componentNetworkOffline.bind(this));
  }
}

/**
 * 页面组件
 * 
 * 该组件主要用于多页面中主入口APP页面组件
 * 
 * 该组件组件默认实现了 `render` ，并对外提供了 `renderContent` 以替代 `React.Component` 的 `render` ，该组件内置了 **页面初始化的加载中提示** 和 **网络异常时的提示**
 */
export class PageComponent<P = {}, S = {}, SS = any> extends DingComponent<P, S, SS> {
  execute: () => void = () => {}

  componentWillMount () {
    super.componentWillMount()
    window.addEventListener('orientationchange' in window ? 'orientationchange' : 'resize',this.componentResize.bind(this),false)
    EventDriver.register("networkError",this.updateNetworkError.bind(this));
    EventDriver.register("catchError",this.updateCatchError.bind(this));
  }

  componentDidMount () {
    
  }

  componentWillUnmount () {
    super.componentWillUnmount()
    EventDriver.unregister("networkError",this.updateNetworkError.bind(this));
    EventDriver.unregister("catchError",this.updateCatchError.bind(this));
  }

  componentNetworkOffline () {
    window.networkAnomaly = true
  }

  componentNetworkOnline () {
    window.networkAnomaly = false
  }

  /** 应用窗口被调整 */
  componentResize () {
    let state: any = {}
    state['width'] = window.innerWidth
    state['height'] = window.innerHeight
    this.setState(state)
  }

  /**
   * 触发 未知异常
   * @param _message 
   */
  updateCatchError (_message: {errorText: string, errorType: ErrorType, errorMessage: any}) {
    let state: any = {}
    state['load'] = true
    state['catchError'] = _message
    this.setState(state)
    if (!DingTalk.isDingTalk) {
      if (!errorLock) {
        errorLock = true
        message.error(_message.errorText, undefined, () => errorLock = false)
      }
    }
  }

  /**
   * 触发 网络连接错误
   * @param networkError 网络是否连接出错
   * @param execute 重新尝试连接
   */
  updateNetworkError (networkError: boolean ,execute: () => void) {
    let state: any = {}
    state['networkError'] = networkError
    this.setState(state)
    this.execute = execute
  }

  renderContent () : React.ReactNode {
    return
  }

  renderErrorContent () : React.ReactNode {
    const {errorText, errorType, errorMessage} = this.state['catchError'] as {errorText: string, errorType: ErrorType, errorMessage: any}
    let img = <Icon type="cross-circle-o" className="spe" style={{ fill: '#F13642' }} />, title = '', message = ''
    switch (errorType) {
      case ErrorType.known:
        title = '操作失败'
        message = errorText
        break;
      case ErrorType.permissions:
        img = <img src={'https://gw.alipayobjects.com/zos/rmsportal/GIyMDJnuqmcqPLpHCSkj.svg'} className="spe am-icon am-icon-md" alt="" />;
        title = '没有权限访问'
        message = errorText
        break;
      case ErrorType.unknown:
      default:
        title = '未知错误'
        break;
    }
    DingTalk.setTitle(title)
    DingTalk.setRight('刷新', () => {window.location.reload()})
    return (
      <>
        <Result img={img} title={title} message={message}/>
        <span style={{width: window.innerWidth, marginTop: 20, whiteSpace: 'pre-wrap'}}>{window.baseConfig.development && JsonHelper.toJson(errorMessage)}</span>
      </>
    );
  }

  render() {
    const height = this.state['height'] ? this.state['height'] + 'px' : '100%'
    const load = !!this.state['load']
    const LoadView = (
      <img className="App-loading" src="/img/load.gif" alt="" />
    );
    const ContentView = () => {
      if (this.state['catchError']) {
        if (DingTalk.isDingTalk) {
          return this.renderErrorContent()
        } else {
          return load ? this.renderContent() : LoadView
        }
        
      } else {
        return load ? this.renderContent() : LoadView
      }
    }
    return (
      <div className="App" style={{ width: '100%', minHeight: height }}>
        { this.renderNetworkError() }
        { ContentView() }
      </div>
    );
  }

  /**
   * 当网络连接错误时显示
   */
  renderNetworkError () {
    if (this.state['networkError']) {
      return (
        <Alert showIcon={false} closeText="点击重试" message="网络不可用，请联网后重试" banner closable onClose={() => {
          this.execute()
          let state: any = {}
          state['networkError'] = false
          this.setState(state)
        }}/>
      );
    }
    return
  }
  
}

/**
 * 具备提交监听事件的 页面组件
 * 继承 PageComponent 页面组件，添加对提交的监听
 */
export class SubmitPageComponent<P = {}, S = {}, SS = any> extends PageComponent<P, S, SS> {
  
  componentWillMount () {
    super.componentWillMount()
    EventDriver.register("lockSubmit",this.updateLock2Submit.bind(this));
  }

  componentWillUnmount () {
    super.componentWillUnmount()
    EventDriver.unregister("lockSubmit",this.updateLock2Submit.bind(this));
  }

  /**
   * 更新 lockSubmit
   */
  updateLock2Submit (isError?: boolean) {
    // console.log('super.updateLock2Submit' + window.lockSubmit);
    // doSomething
  }
}


// WEBPACK FOOTER //
// ./src/components/PageComponent/index.tsx